import { useAppSelector } from 'store/hooks';
import { selectActiveZoomId } from 'features/content-zoom/contentZoomSlice';
import { selectCurrentOpenedContent } from 'features/layout/features/content/contentSlice';

export const useZoomControlVisibility = () => {
  const zoomId = useAppSelector(selectActiveZoomId);
  const content = useAppSelector(selectCurrentOpenedContent);

  const visible = !!zoomId;

  return {
    zoomId: zoomId ?? '',
    visible,
    isScreenshare: content?.type === 'screenshare',
  };
};
